import { Schema } from "@comparaonline/products-schema";

import { getHostname } from "../../../core/helpers";

type GetDetailUrl = (
  countryCode: string,
  businessUnitSlug: string,
  product: Schema.ProductListProduct
) => string;
export const getDetailUrl: GetDetailUrl = (countryCode, businessUnitSlug, product) =>
  `${getHostname(countryCode)}/${businessUnitSlug}/product/${product.division.slug}/${
    product.slug
  }`;
